import { a as createCommonjsModule } from '../common/_commonjsHelpers-a3307dcf.js';
import { r as react } from '../common/index-2e5f2345.js';
import { c as createHook, _ as _rollupPluginBabelHelpers8f9a8751, a as createComponent } from '../common/Role-467268c3.js';
import { T as Tabbable_1, u as useLiveRef, i as isButton, a as useForkRef } from '../common/Tabbable-6f592cce.js';

/**
 * Returns `true` if `event.target` and `event.currentTarget` are the same.
 */
function isSelfTarget(event) {
  return event.target === event.currentTarget;
}

var isSelfTarget$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isSelfTarget: isSelfTarget
});

var Clickable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });



















// Automatically generated
var CLICKABLE_KEYS = ["unstable_clickOnEnter", "unstable_clickOnSpace"];

function isNativeClick(event) {
  var element = event.currentTarget;
  if (!event.isTrusted) return false; // istanbul ignore next: can't test trusted events yet

  return isButton.isButton(element) || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "A" || element.tagName === "SELECT";
}

var useClickable = createHook.createHook({
  name: "Clickable",
  compose: Tabbable_1.useTabbable,
  keys: CLICKABLE_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$unstable_clickOn = _ref.unstable_clickOnEnter,
        unstable_clickOnEnter = _ref$unstable_clickOn === void 0 ? true : _ref$unstable_clickOn,
        _ref$unstable_clickOn2 = _ref.unstable_clickOnSpace,
        unstable_clickOnSpace = _ref$unstable_clickOn2 === void 0 ? true : _ref$unstable_clickOn2,
        options = _rollupPluginBabelHelpers8f9a8751._objectWithoutPropertiesLoose(_ref, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);

    return _rollupPluginBabelHelpers8f9a8751._objectSpread2({
      unstable_clickOnEnter: unstable_clickOnEnter,
      unstable_clickOnSpace: unstable_clickOnSpace
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlOnKeyDown = _ref2.onKeyDown,
        htmlOnKeyUp = _ref2.onKeyUp,
        htmlProps = _rollupPluginBabelHelpers8f9a8751._objectWithoutPropertiesLoose(_ref2, ["onKeyDown", "onKeyUp"]);

    var _React$useState = react.useState(false),
        active = _React$useState[0],
        setActive = _React$useState[1];

    var onKeyDownRef = useLiveRef.useLiveRef(htmlOnKeyDown);
    var onKeyUpRef = useLiveRef.useLiveRef(htmlOnKeyUp);
    var onKeyDown = react.useCallback(function (event) {
      var _onKeyDownRef$current;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;
      if (options.disabled) return;
      if (event.metaKey) return;
      if (!isSelfTarget$1.isSelfTarget(event)) return;
      var isEnter = options.unstable_clickOnEnter && event.key === "Enter";
      var isSpace = options.unstable_clickOnSpace && event.key === " ";

      if (isEnter || isSpace) {
        if (isNativeClick(event)) return;
        event.preventDefault();

        if (isEnter) {
          event.currentTarget.click();
        } else if (isSpace) {
          setActive(true);
        }
      }
    }, [options.disabled, options.unstable_clickOnEnter, options.unstable_clickOnSpace]);
    var onKeyUp = react.useCallback(function (event) {
      var _onKeyUpRef$current;

      (_onKeyUpRef$current = onKeyUpRef.current) === null || _onKeyUpRef$current === void 0 ? void 0 : _onKeyUpRef$current.call(onKeyUpRef, event);
      if (event.defaultPrevented) return;
      if (options.disabled) return;
      if (event.metaKey) return;
      var isSpace = options.unstable_clickOnSpace && event.key === " ";

      if (active && isSpace) {
        setActive(false);
        event.currentTarget.click();
      }
    }, [options.disabled, options.unstable_clickOnSpace, active]);
    return _rollupPluginBabelHelpers8f9a8751._objectSpread2({
      "data-active": active || undefined,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp
    }, htmlProps);
  }
});
var Clickable = createComponent.createComponent({
  as: "button",
  memo: true,
  useHook: useClickable
});

exports.Clickable = Clickable;
exports.useClickable = useClickable;
});

var Button_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });




















// Automatically generated
var BUTTON_KEYS = [];

var useButton = createHook.createHook({
  name: "Button",
  compose: Clickable_1.useClickable,
  keys: BUTTON_KEYS,
  useProps: function useProps(_, _ref) {
    var htmlRef = _ref.ref,
        htmlProps = _rollupPluginBabelHelpers8f9a8751._objectWithoutPropertiesLoose(_ref, ["ref"]);

    var ref = react.useRef(null);

    var _React$useState = react.useState(undefined),
        role = _React$useState[0],
        setRole = _React$useState[1];

    var _React$useState2 = react.useState("button"),
        type = _React$useState2[0],
        setType = _React$useState2[1];

    react.useEffect(function () {
      var element = ref.current;

      if (!element) {
        return;
      }

      if (!isButton.isButton(element)) {
        if (element.tagName !== "A") {
          setRole("button");
        }

        setType(undefined);
      }
    }, []);
    return _rollupPluginBabelHelpers8f9a8751._objectSpread2({
      ref: useForkRef.useForkRef(ref, htmlRef),
      role: role,
      type: type
    }, htmlProps);
  }
});
var Button = createComponent.createComponent({
  as: "button",
  memo: true,
  useHook: useButton
});

exports.Button = Button;
exports.useButton = useButton;
});

var Button = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });























exports.Button = Button_1.Button;
exports.useButton = Button_1.useButton;
});

var Button$1 = Button.Button;
export { Button$1 as Button };
